import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";

const AudioPlayer = ({ file }) => {
  const [audioSrc, setAudioSrc] = useState(null);

  useEffect(() => {
    if (!file) {
      setAudioSrc(null);
      return;
    }

    const url = URL.createObjectURL(file.get("file"));
    setAudioSrc(url);

    return () => URL.revokeObjectURL(url);
  }, [file]);

  return (
    <Box sx={{ width: 400, paddingBottom: 1 }}>
      {audioSrc ? (
        <Box mt={2}>
          <audio controls src={audioSrc} style={{ width: "100%" }} />
        </Box>
      ) : (
        <Typography variant="body2" color="textSecondary">
          No audio file loaded.
        </Typography>
      )}
    </Box>
  );
};

export default AudioPlayer;
